<div class="discover-paging">
  <div>
    <div class="pager" (click)="navigateTo(currentSlide - 1)">
      <div class="icon left"></div>
    </div>
  </div>
  <div>Seite {{ currentSlide + 1 }} / {{ totalSlides }}</div>
  <div>
    <div class="pager" (click)="navigateTo(currentSlide + 1)">
      <div class="icon right"></div>
    </div>
  </div>
</div>
